export default "__VITE_ASSET__d9ab25a5__"